module.exports = __webpack_public_path__ + "static/1-f93e323ea105ecf6f8a88aa508673701.png";